import { useEffect, useState } from "react";
import { getDashboardCard } from "@src/api/por";

function readCachedDashboard(cacheKey) {
  try {
    const raw = localStorage.getItem(cacheKey);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function writeCachedDashboard(cacheKey, result) {
  try {
    localStorage.setItem(cacheKey, JSON.stringify(result));
  } catch {
    // Ignore quota / privacy errors.
  }
}

export default function usePorDashboard(projectId, cacheKey) {
  const [dashboard, setDashboard] = useState(() => readCachedDashboard(cacheKey));
  const [isSettled, setIsSettled] = useState(false);

  useEffect(() => {
    let cancelled = false;

    getDashboardCard(projectId)
      .then((response) => {
        if (!cancelled && response?.rc === 0 && response.result) {
          setDashboard(response.result);
          writeCachedDashboard(cacheKey, response.result);
        }
      })
      .catch(() => {})
      .finally(() => {
        if (!cancelled) {
          setIsSettled(true);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [projectId, cacheKey]);

  return { dashboard, isSettled };
}
